import { api } from "..";

import { QueryProps } from "@/types/Api";

interface SearchCouponsNamesParams {}

export const getCouponsNames = async (
  props: QueryProps<SearchCouponsNamesParams>
): Promise<string[]> => {
  const res = await api.client.get(`/users-new/coupons/names`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
